<section class="w-full">
    <div class="container px-5 py-10 mx-auto">
       
        <div class="flex flex-wrap">
            <div class="w-full px-4">
                <div class="text-center mx-auto mb-12 max-w-2xl">
                    <h2 class="font-bold text-3xl sm:text-4xl md:text-[40px] text-dark mb-4">
                        Testimonials
                    </h2>
                    <p class="text-base text-body-color">
                        Our customers' experiences speak for themselves! From seamless bookings to unforgettable adventures, we take pride in making every journey special. See what our happy travelers have to say about their incredible trips with us.
                    </p>
                </div>
            </div>
        </div>

        @if(view.testimonials) {
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
                @for(item of view.testimonials.content; track item) {
                    <fuse-card class="w-full">
                        <div class="h-full bg-white p-4 hover:shadow-lg dark:bg-slate-700">
                            <div class="flex justify-between items-center">
                                <mat-icon class="icon-size-12 text-primary-400" svgIcon="mat_solid:format_quote"></mat-icon>
                                <div class="flex">
                                    <mat-icon class="icon-size-5 text-primary-600" svgIcon="mat_solid:star"></mat-icon>
                                    <mat-icon class="icon-size-5 text-primary-600" svgIcon="mat_solid:star"></mat-icon>
                                    <mat-icon class="icon-size-5 text-primary-600" svgIcon="mat_solid:star"></mat-icon>
                                    <mat-icon class="icon-size-5 text-primary-600" svgIcon="mat_solid:star"></mat-icon>
                                </div>
                            </div>
                            <p class="leading-relaxed mb-15" [innerHTML]="item.rawContentShort"></p>
                            @if(item.name || item.tagline) {
                            <div class="absolute bottom-4 left-4">
                                    <span class="title-font font-medium text-gray-900 block">{{item.name}}</span>
                                    <span class="text-primary-500 text-sm block">{{item.tagline}}</span>
                                </div>
                            }
                        </div>
                    </fuse-card>
                }
            </div>
        }
    </div>
</section>